
// themify icons: https://themify.me/themify-icons
// material design icons: https://pictogrammers.com/library/mdi/
import { Component, Vue, Prop } from 'vue-property-decorator'
import LoginModal from './LoginModal.vue'
import SignUpModal from './SignUpModal.vue'
import Sidebar from './Sidebar.vue'
import FetchWrapper from '@/classes/fetchWrapper'
import store from '../store'

Vue.prototype.$multiwatch = function (props, watcher) {
  var iterator = function (prop) {
    this.$watch(prop, watcher)
  }
  props.forEach(iterator, this)
}

@Component({
  components: {
    LoginModal,
    SignUpModal,
    Sidebar
  }
})
export default class NavBar extends Vue {
  @Prop({ required: false, default: false })readonly emitBeforeLogout: boolean | false
  @Prop({ required: false, default: false })readonly fireLogout: boolean | false
  data () {
    return {
      isLoading: false,
      closeLoginModal: false,
      signUpModal: false,
      base_url: process.env.BASE_URL,
      internalEmitBeforeLogout: true,
      roles: [],
      isTutor: false,
      isTeacher: false,
      isAdmin: false,
      isStudent: false,
      loggedUserId: null,
      users: [],
      allOtherUsers: [],
      allUsers: [],
      allStudents: [],
      studentsUnderTutor: [],
      studentsUnderTeacher: [],
      selectedUserId: null,
      canSelectUser: false,
      isThereNewChatMessage: false,
      newMessageTimeoutId: null,
      title: '',
      urlPath: '',
      unreadUserChats: [],
      nextOnboardingCheckpoint: null,
      displayDarkBackground: false,
      displayCheckpointBtn: false,
      // checkpointModal: null,
      displayCheckpointModal: false,
      displayCheckpointModalMobile: false,
      showSetCheckpointBtn: false,
      isMobileScreen: true,
      openSidebar: false,
      canHideSidebar: true,
      ready: false
    }
  }

  created () {
    this.$multiwatch(['fireLogout'], function () {
      if (this.fireLogout) {
        this.internalEmitBeforeLogout = false
        this.logout()
      }
    })
    this.$multiwatch(['selectedUserId'], function () {
      this.$store.commit('selectedUserId', this.selectedUserId)
      this.$emit('changedUserId')
    })
    this.$multiwatch(['isThereNewChatMessage'], function () {
      if (!this.newMessageTimeoutId && this.isThereNewChatMessage/* && window.location.pathname !== '/home/chats' */) {
        this.newMessageTimeoutId = setInterval(this.blinkTitle, 1000)
      } else {
        document.title = this.title
        clearInterval(this.newMessageTimeoutId)
        this.newMessageTimeoutId = null
      }
    })
    this.$multiwatch(['nextOnboardingCheckpoint'], function () {
      this.displayCheckpoint()
      // this.$emit('changedUserId')
    })
    this.$multiwatch(['nextOnboardingCheckpoint'], function () {
      this.canHideSidebar = !this.nextOnboardingCheckpoint
    })
  }

  mounted () {
    window.addEventListener('resize', this.updateWindowSize)
    this.updateWindowSize()
    this.title = document.title
    this.urlPath = window.location.pathname
    this.roles = store.getters.getUserRoles
    this.isTutor = this.roles ? this.roles.includes('TUTOR') : false
    this.isTeacher = this.roles ? this.roles.includes('TEACHER') : false
    this.isAdmin = this.roles ? this.roles.includes('ADMIN') : false
    this.isStudent = this.roles ? this.roles.includes('STUDENT') : false
    var user = store.getters.getLoggedUserIdAndName
    if (user) {
      this.loggedUserId = user.id
      this.loggedUserName = user.name
    }
    this.init()
    if (this.isLoggedIn && !this.isAdmin) {
      this.getUnreadUserChats()
      this.unreadUserChatsIntervalId = setInterval(this.getUnreadUserChats, 5000)
      this.getNextOnboardingCheckPoint()
    }
  }

  formattedText (text) {
    if (text) {
      return text.replace(/\n/g, '<br>')
    } else {
      return ''
    }
  }

  async init () {
    if (this.loggedUserId) {
      if (['/home/users', '/home/videos', '/home/collections', '/home/chats', '/home/calls', '/stats'].indexOf(window.location.pathname) > -1 || window.location.pathname.includes('/home/callTranscript')) {
        this.canSelectUser = false
      } else {
        this.canSelectUser = true
      }
      if (window.location.pathname === '/students') {
        if (this.isTeacher) {
          await this.getTeacherStudents()
        } else if (this.isTutor) {
          await this.getTutorStudents()
        }
        if (this.users.findIndex(e => e.id === this.$store.getters.getSelectedUserId) === -1) {
          this.$store.commit('selectedUserId', null)
          // this.$store.commit('selectedUserId', this.loggedUserId)
        }
        this.selectedUserId = this.$store.getters.getSelectedUserId
      } else if (window.location.pathname === '/home/profile' || window.location.pathname === '/home/templates') {
        if (this.isTeacher) {
          await this.getTeacherStudents()
        } else if (this.isTutor) {
          await this.getTutorStudents()
        } else if (this.isAdmin) {
          await this.getUsers()
          this.users = this.allUsers
        }
        if (this.isTutor || this.isTeacher) {
          this.users.push({ id: this.loggedUserId, name: this.loggedUserName })
        }
        if (this.users.findIndex(e => e.id === this.$store.getters.getSelectedUserId) === -1) {
          this.$store.commit('selectedUserId', this.loggedUserId)
        }
        this.selectedUserId = this.$store.getters.getSelectedUserId
      } else {
        await this.getUsers()
        this.users = this.allOtherUsers
      }
    }
  }

  get isLoggedIn () {
    return this.$store.state.loggedIn
  }

  goToUsersView () {
    // :href="`${base_url}home/users`"
    this.$store.commit('selectedUserId', null)
    window.location.href = '/home/users'
  }

  goToTemplatesView () {
    // :href="`${base_url}home/templates`"
    window.location.href = '/home/templates'
  }

  goToProfileView () {
    // :href="`${base_url}home/profile`"
    if (this.isStudent) {
      this.$store.commit('selectedUserId', null)
    }
    window.location.href = '/home/profile'
  }

  goToVideosView () {
  // :href="`${base_url}home/videos`"
    this.$store.commit('selectedUserId', null)
    window.location.href = '/home/videos'
  }

  goToCollectionsView () {
  // :href="`${base_url}home/collections`"
    this.$store.commit('selectedUserId', null)
    window.location.href = '/home/collections'
  }

  goToChatsView () {
  // :href="`${base_url}home/chats`"
    this.$store.commit('selectedUserId', null)
    window.location.href = '/home/chats'
  }

  goToCallsView () {
  // :href="`${base_url}home/calls`"
    this.$store.commit('selectedUserId', null)
    window.location.href = '/home/calls'
  }

  goToStatsView () {
  // :href="`${base_url}stats`"
    this.$store.commit('selectedUserId', null)
    window.location.href = '/stats'
  }

  blinkTitle () {
    document.title = document.title === 'New chat message!' ? this.title : 'New chat message!'
  }

  displayCheckpoint () {
    if (this.nextOnboardingCheckpoint) {
      this.displayDarkBackground = true
      if (this.isMobileScreen) {
        this.displayCheckpointModal = false
        this.displayCheckpointModalMobile = true
        this.openSidebar = true
        // setTimeout(() => {
        this.updateCheckPointDisplayItems()
        // }, 1000)
      } else {
        this.displayCheckpointModal = true
        this.displayCheckpointModalMobile = false
        this.updateCheckPointDisplayItems()
      }
    } else {
      this.displayDarkBackground = false
      this.displayCheckpointModal = false
      this.displayCheckpointModalMobile = false
    }
    /* this.showSetCheckpointBtn =
      (this.urlPath === '/home/chats' && this.nextOnboardingCheckpoint?.step === 0) ||
      (this.urlPath === '/home/videos' && this.nextOnboardingCheckpoint?.step === 1) ||
      (this.urlPath === '/home/collections' && this.nextOnboardingCheckpoint?.step === 2) ||
      (this.urlPath === '/home/tasks' && this.nextOnboardingCheckpoint?.step === 3) ||
      (this.urlPath === '/home/calls' && this.nextOnboardingCheckpoint?.step === 4) ||
      (this.urlPath === '/home/curation' && this.nextOnboardingCheckpoint?.step === 5) ||
      (this.urlPath === '/home/freespeaking' && this.nextOnboardingCheckpoint?.step === 6) ||
      (this.urlPath === '/home/freewriting' && this.nextOnboardingCheckpoint?.step === 7) ||
      (this.urlPath === '/stats' && this.nextOnboardingCheckpoint?.step === 8) ||
      (this.urlPath === '/home/profile' && this.nextOnboardingCheckpoint?.step === 9) */
  }

  updateCheckPointDisplayItems () {
    switch (this.nextOnboardingCheckpoint.step) {
      case 0:
        this.showSetCheckpointBtn = true
        break
      case 1:
        this.showSetCheckpointBtn = this.urlPath === '/home/chats'
        this.$refs.chatsNavbarItem.$el.scrollIntoView()
        this.$refs.chatsNavbarItemMobile.$el.scrollIntoView()
        break
      case 2:
        this.showSetCheckpointBtn = this.urlPath === '/home/videos'
        this.$refs.videosNavbarItem.$el.scrollIntoView()
        this.$refs.videosNavbarItemMobile.$el.scrollIntoView()
        break
      case 3:
        this.showSetCheckpointBtn = this.urlPath === '/home/collections'
        this.$refs.collectionsNavbarItem.$el.scrollIntoView()
        this.$refs.collectionsNavbarItemMobile.$el.scrollIntoView()
        break
      case 4:
        this.showSetCheckpointBtn = this.urlPath === '/home/tasks'
        this.$refs.tasksNavbarItem.$el.scrollIntoView()
        this.$refs.tasksNavbarItemMobile.$el.scrollIntoView()
        break
      case 5:
        this.showSetCheckpointBtn = this.urlPath === '/home/calls'
        this.$refs.callsNavbarItem.$el.scrollIntoView()
        this.$refs.callsNavbarItemMobile.$el.scrollIntoView()
        break
      case 6:
        this.showSetCheckpointBtn = this.urlPath === '/home/curation'
        this.$refs.curationNavbarItem.$el.scrollIntoView()
        this.$refs.curationNavbarItemMobile.$el.scrollIntoView()
        break
      case 7:
        this.showSetCheckpointBtn = this.urlPath === '/home/freeSpeaking'
        this.$refs.freespeakingNavbarItem.$el.scrollIntoView()
        this.$refs.freespeakingNavbarItemMobile.$el.scrollIntoView()
        break
      case 8:
        this.showSetCheckpointBtn = this.urlPath === '/home/freeWriting'
        this.$refs.freewritingNavbarItem.$el.scrollIntoView()
        this.$refs.freewritingNavbarItemMobile.$el.scrollIntoView()
        break
      case 9:
        this.showSetCheckpointBtn = this.urlPath === '/stats'
        this.$refs.statsNavbarItem.$el.scrollIntoView()
        this.$refs.statsNavbarItemMobile.$el.scrollIntoView()
        break
      case 10:
        this.showSetCheckpointBtn = this.urlPath === '/home/profile'
        this.$refs.profileNavbarItem.$el.scrollIntoView()
        this.$refs.profileNavbarItemMobile.$el.scrollIntoView()
    }
    this.ready = true
  }

  getBtnClass (step) {
    if (this.nextOnboardingCheckpoint && this.nextOnboardingCheckpoint.step === step) {
      return 'highlithed-item'
    } else {
      return ''
    }
  }

  sidebarClosed () {
    if (!this.displayCheckpointModalMobile) {
      this.openSidebar = false
    }
  }

  requestToOpenSidebar () {
    this.openSidebar = true
  }

  updateWindowSize () {
    this.isMobileScreen = window.innerWidth <= 700
    if (this.nextOnboardingCheckpoint && this.isMobileScreen) {
      this.requestToOpenSidebar()
    }
    if (this.nextOnboardingCheckpoint && !this.isMobileScreen) {
      this.sidebarClosed()
    }
    this.displayCheckpoint()
  }

  async logout () {
    if (this.emitBeforeLogout && this.internalEmitBeforeLogout) {
      this.$emit('logoutRequested')
    } else {
      this.isLoading = true
      try {
        await FetchWrapper.get(encodeURI(`${process.env.VUE_APP_SERVERURL}/logout`))
        this.isLoading = false
        this.$store.commit('loggedIn', false)
        this.$store.commit('accessToken', null)
        this.$store.commit('selectedUserId', null)

        this.closeLoginModal = false
        this.$router.push('/home')
        // window.href = '/home'
      } catch (e) {
        this.isLoading = false
        this.$buefy.dialog.confirm({
          title: 'Error',
          message: `Could not logout. ${e}`,
          canCancel: false
        })
      }
    }
  }

  async getUsers () {
    try {
      var resp = await FetchWrapper.get(encodeURI(`${process.env.VUE_APP_SERVERURL}/getUsers`))
      this.allUsers = resp
      this.allOtherUsers = resp.filter(e => e.id !== this.loggedUserId)
      this.allStudents = this.users.filter(e => e.roles.includes('STUDENT'))
      this.selectedUserId = this.$store.getters.getSelectedUserId
    } catch (e) {
      this.$buefy.dialog.confirm({
        title: 'Error',
        message: 'Could not get Users.',
        canCancel: false
      })
    }
  }

  async getTutorStudents () {
    try {
      var resp = await FetchWrapper.get(encodeURI(`${process.env.VUE_APP_SERVERURL}/students/getTutorStudents`))
      this.studentsUnderTutor = resp
      this.users = this.studentsUnderTutor
    } catch (e) {
      this.$buefy.dialog.confirm({
        title: 'Error',
        message: 'Could not get tutor students.',
        canCancel: false
      })
    }
  }

  async getTeacherStudents () {
    try {
      var resp = await FetchWrapper.get(encodeURI(`${process.env.VUE_APP_SERVERURL}/students/getTeacherStudents`))
      this.studentsUnderTeacher = resp
      this.users = this.studentsUnderTeacher
      /* if (this.users.findIndex(e => e.id === this.$store.getters.getSelectedUserId) === -1) {
        // this.$store.commit('selectedUserId', null)
        this.$store.commit('selectedUserId', this.loggedUserId)
      }
      this.selectedUserId = this.$store.getters.getSelectedUserId */
    } catch (e) {
      this.$buefy.dialog.confirm({
        title: 'Error',
        message: 'Could not get teacher students.',
        canCancel: false
      })
    }
  }

  async getUnreadUserChats () {
    if (!this.isLoggedIn) {
      clearInterval(this.unreadUserChatsIntervalId)
    } else {
      try {
        var resp = await FetchWrapper.get(encodeURI(`${process.env.VUE_APP_SERVERURL}/getUnreadUserChats`))
        this.unreadUserChats = resp
        this.$emit('unreadUserChats', this.unreadUserChats)
        if (this.unreadUserChats.length > 0) {
          this.isThereNewChatMessage = true
        } else {
          this.isThereNewChatMessage = false
        }
      } catch (e) {
        console.error(e)
      }
    }
  }

  async getNextOnboardingCheckPoint () {
    try {
      var resp = await FetchWrapper.get(encodeURI(`${process.env.VUE_APP_SERVERURL}/getNextOnboardingCheckpoint`))
      if (this.isMobileScreen) {
        this.displayCheckpointModalMobile = resp !== null
      } else {
        this.displayCheckpointModal = resp !== null
      }
      this.nextOnboardingCheckpoint = resp

      // this.$emit('unreadUserChats', this.unreadUserChats)
      /* if (this.unreadUserChats.length > 0) {
        this.isThereNewChatMessage = true
      } else {
        this.isThereNewChatMessage = false
      } */
    } catch (e) {
      console.error(e)
    }
  }

  async setCheckpointCompleted () {
    try {
      var resp = await FetchWrapper.get(encodeURI(`${process.env.VUE_APP_SERVERURL}/setCheckpointCompleted/${this.nextOnboardingCheckpoint.id}`))
      if (this.nextOnboardingCheckpoint.step === 0) {
        // window.location.href = window.location.pathname
        this.getNextOnboardingCheckPoint()
      } else {
        if (this.isMobileScreen) {
          this.displayCheckpointModalMobile = resp !== null
        } else {
          this.displayCheckpointModal = resp !== null
        }
        setInterval(() => { this.nextOnboardingCheckpoint = resp }, 400)
      }

      // this.$emit('unreadUserChats', this.unreadUserChats)
      /* if (this.unreadUserChats.length > 0) {
        this.isThereNewChatMessage = true
      } else {
        this.isThereNewChatMessage = false
      } */
    } catch (e) {
      console.error(e)
    }
  }
}
